import { Control, Controller, UseFormSetValue } from 'react-hook-form';
import { CreateProductFormSchemaType, useGenerateDetailTitle } from '../common';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { useCallback, useMemo } from 'react';
import { SelectOption } from 'types/base';
import { useAppSelector } from 'store/hooks';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';
import { Select } from 'antd';

const ProductStamp = ({
  control,
  setValue,
}: {
  control: Control<CreateProductFormSchemaType>;
  setValue: UseFormSetValue<CreateProductFormSchemaType>;
}) => {
  const { stampSelectOptions } = useAppSelector(selectGlobalInfo);
  const stampListSort = useMemo((): SelectOption[] => {
    if (stampSelectOptions && stampSelectOptions.length) {
      return [...stampSelectOptions].sort(
        (a: SelectOption, b: SelectOption) => b.sort! - a.sort!
      );
    }
    return [];
  }, [stampSelectOptions]);

  const SelectFilter = useCallback(
    (input: string, option: SelectOption | undefined) =>
      (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
    []
  );
  const { generateDetailTitle } = useGenerateDetailTitle(control);

  return (
    <div className="flex items-center gap-2">
      <FormLabel>{i18n.t(LOCALS.stamp)}:</FormLabel>
      <Controller
        name="stamp"
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            className="w-full"
            options={stampListSort}
            filterOption={SelectFilter}
            placeholder={i18n.t(LOCALS.please_select) || ''}
            showSearch
            onChange={(value) => {
              field.onChange(value);
              const detailTitle = generateDetailTitle({
                stamp: value,
              });
              setValue('detailTitle', detailTitle);
            }}
          />
        )}
      />
    </div>
  );
};

export default ProductStamp;
